import * as React from 'react';

import Grid from '@mui/material/Grid';

import { STATS } from '../constants';
import { StatCard } from './index';

function StatSection() {
  return (
    <Grid
      className={'home_page__stat-section-container'}
      container={true}
      justifyContent={'center'}
    >
      <Grid item={true} xs={12} lg={8} className={'home_page__stat-cards-container'}>
        <Grid item={true} xs={5} md={3} className={'home_page__stat-cards-appear card-one'}>
          <StatCard id={'home-page__card-developers'} cardInfo={STATS.developers} />
        </Grid>
        <Grid item={true} xs={5} md={3} className={'home_page__stat-cards-appear card-two'}>
          <StatCard id={'home-page__card-entries'} cardInfo={STATS.entries} />
        </Grid>
        <Grid item={true} xs={5} md={3} className={'home_page__stat-cards-appear card-three'}>
          <StatCard id={'home-page__card-mau'} cardInfo={STATS.mau} />
        </Grid>
        <Grid item={true} xs={5} md={3} className={'home_page__stat-cards-appear card-four'}>
          <StatCard id={'home-page__card-time'} cardInfo={STATS.time} />
        </Grid>
      </Grid>
    </Grid>
  );
}

export { StatSection };
